import { useEffect } from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { oktaAuth } from '../auth';

export default function SignedOutPage() {
  // Clear the logout sentinel that ProtectedRoute reads to skip its
  // signInWithRedirect during the logout race. Without this, a future
  // visit to a protected route would silently fall through.
  useEffect(() => {
    sessionStorage.removeItem('ajo:logout-in-progress');
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom fontWeight={700}>
            You're signed out
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Local tokens for AJO Design Agent have been cleared. To finish
            signing out across all Adobe apps in this browser, close the tab
            (or sign out of Okta directly).
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              variant="contained"
              onClick={() => oktaAuth.signInWithRedirect()}
            >
              Sign in again
            </Button>
            <Button
              variant="outlined"
              onClick={() =>
                oktaAuth
                  .signOut({
                    postLogoutRedirectUri: `${window.location.origin}/signed-out`,
                  })
                  .catch(() => {})
              }
            >
              Sign out of Okta
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
